/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Kódy slev ${i.storeName} vám umožňují dělat dobré nákupy. Některé nabídky jsou platné pouze několik dní. Proto se doporučuje pravidelně navštěvovat tuto stránku.`
};

const da_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Rabatkoder til ${i.storeName} giver dig gode tilbud på dine køb. Nogle tilbud gælder kun i få dage. Besøg derfor denne side regelmæssigt.`
};

const de_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Mit den Rabattcodes von ${i.storeName} können Sie beim Einkauf sparen. Einige Angebote sind nur wenige Tage gültig. Besuchen Sie diese Seite regelmäßig.`
};

const en_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.storeName} discount codes allow you to get great deals on your purchases. Some good deals are only valid for a few days. We therefore recommend visiting this page regularly.`
};

const es_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Los códigos promocionales de ${i.storeName} te permiten conseguir grandes ofertas en tus compras. Algunas promociones solo son válidas unos días. Por eso, te recomendamos visitar esta página regularmente.`
};

const fr_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Les codes promo ${i.storeName} vous permettent de faire de bonnes affaires sur vos achats. Certains bons plans ne sont valables que quelques jours. Il est donc recommandé de visiter cette page régulièrement.`
};

const hu_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `A ${i.storeName} promóciós kódjai lehetővé teszik, hogy jó üzleteket kössön vásárlásakor. Egyes ajánlatok csak néhány napig érvényes. Ezért ajánlott rendszeresen meglátogatni ezt az oldalt.`
};

const it_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `I codici sconto ${i.storeName} ti permettono di risparmiare sui tuoi acquisti. Alcune offerte sono valide solo per pochi giorni. Ti consigliamo di visitare questa pagina regolarmente.`
};

const nl_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Met kortingscodes van ${i.storeName} profiteer je van mooie deals. Sommige aanbiedingen zijn slechts enkele dagen geldig. Bezoek deze pagina dus regelmatig.`
};

const pl_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Kody rabatowe ${i.storeName} pozwalają zaoszczędzić na zakupach. Niektóre promocje są ważne tylko przez kilka dni, więc warto regularnie odwiedzać tę stronę.`
};

const pt_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Os códigos promocionais ${i.storeName} permitem que você faça bons negócios em suas compras. Algumas ofertas são válidas por poucos dias. Por isso, é recomendável visitar esta página regularmente.`
};

const sv_discount_codes_description = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Rabattkoder från ${i.storeName} hjälper dig att göra bra affärer. Vissa erbjudanden gäller bara några dagar, så besök sidan regelbundet.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ storeName: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_description = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_description", locale)
	if (locale === "cs") return cs_discount_codes_description(inputs)
	if (locale === "da") return da_discount_codes_description(inputs)
	if (locale === "de") return de_discount_codes_description(inputs)
	if (locale === "en") return en_discount_codes_description(inputs)
	if (locale === "es") return es_discount_codes_description(inputs)
	if (locale === "fr") return fr_discount_codes_description(inputs)
	if (locale === "hu") return hu_discount_codes_description(inputs)
	if (locale === "it") return it_discount_codes_description(inputs)
	if (locale === "nl") return nl_discount_codes_description(inputs)
	if (locale === "pl") return pl_discount_codes_description(inputs)
	if (locale === "pt") return pt_discount_codes_description(inputs)
	return sv_discount_codes_description(inputs)
};
export { discount_codes_description as "discount_codes.description" }